//#region IMPORT
import React, { useEffect, useState } from 'react';
import M_TBG_BASIC_04 from './M_TBG_BASIC_04';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import 'pdfjs-dist/build/pdf.worker.entry';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';
//#endregion

function M_TBG_BASIC_04F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const [fullUrl, setFullUrl] = useState();
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfFile, setPdfFile] = useState();
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1); // 100% 화면 너비로 시작
  const [pageViewHeight, setPageViewHeight] = useState(0); // 페이지 렌더링 높이 상태 추가
  const [renderPreview, setRenderPreview] = useState([]);
  const [pdfImages, setPdfImages] = useState([]);
  //#endregion

  //#region 이벤트
  useEffect(() => {
    Init();
    const handleResize = () => {
      setPageWidth(window.innerWidth * 1); // 화면 크기 바뀔 때 다시 계산
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (pdfFile) {
      const full = Global.file.useUrl + 'files/' + pdfFile;
      setFullUrl(full);
    }
  }, [pdfFile]);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [pageNumber]);

  const Init = async () => {
    setLoading(true);

    try {
      await SearchLogic1();
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 조회

  const SearchLogic1 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R5',
            _CUST_CD: Commons.EncryptAES(userInfo.custCd),
            _DEP_CD: Commons.EncryptAES(userInfo.depCd),
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          const path = data[0].FILE_PATH.replace(/\.[^/.]+$/, '.pdf');
          const full = Global.file.useUrl + 'files/' + path;

          setPdfFile(path);
          setFullUrl(full);

          // PDF 이미지 미리보기 생성
          if (getExtensionFromUrl(path) === 'pdf') {
            generatePdfPreview(full);
          }
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 나머지 함수
  const getExtensionFromUrl = (url = '') => {
    const parts = url?.split('.');
    return parts?.length > 1 ? parts.pop().toLowerCase() : '';
  };

  // PDF 미리보기
  const generatePdfPreview = async (url) => {
    // 원본 PDF 파일을 fetch
    const response = await fetch(url);
    const blob = await response.blob();
    const base64 = await BlobToBase64(blob);

    // 상태에 저장해서 뷰어에 사용
    setRenderPreview(base64);
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber(pageNumber - 1);
    } else {
      dispatch(CommonActions.setActiveStep(activeStep - 1));
    }
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setLoading(true);
      setPageNumber(pageNumber + 1);
    }
  };

  // blob을 base64로 변환
  const BlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  //#endregion

  return (
    <M_TBG_BASIC_04
      userInfo={userInfo}
      pdfFile={pdfFile}
      loading={loading}
      setLoading={setLoading}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      pageNumber={pageNumber}
      pageWidth={pageWidth}
      numPages={numPages}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      pdfImages={pdfImages}
      setPdfImages={setPdfImages}
      pageViewHeight={pageViewHeight}
      setPageViewHeight={setPageViewHeight}
      // 함수
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
      ActiveButton={props.ActiveButton}
      getExtensionFromUrl={getExtensionFromUrl}
      renderPreview={renderPreview}
      fullUrl={fullUrl}
    />
  );
}

export default M_TBG_BASIC_04F;
